import getEnvironmentVariable from '@infotech/helper-get-enviroment-variable'

export const REPORTS_CORE_URL = `${getEnvironmentVariable(
  `REACT_APP_REPORTS_CORE_URL`,
  process.env.REACT_APP_REPORTS_CORE_URL
)}`

export const REACT_APP_REFERENSE_PASSPORT = `${getEnvironmentVariable(
  `REACT_APP_REFERENSE_PASSPORT`,
  process.env.REACT_APP_REFERENSE_PASSPORT
)}`

export const ESUZ_CORE_URL = `/esuz`
export const TOIR_CORE_URL = `/toir`
